import CountUp from 'react-countup';
import { useDashboard } from './Dashboardapi';
import { useNavigate } from "react-router-dom";


const Dashboard = () => {
    const navigate = useNavigate();
    const { data: getWidget } = useDashboard()

    const totalDay = getWidget?.data?.data?.depositDay + getWidget?.data?.data?.withdrawDay + getWidget?.data?.data?.internalDay;
    const totalWeek = getWidget?.data?.data?.depositWeek + getWidget?.data?.data?.withdrawWeek + getWidget?.data?.data?.internalWeek;
    const totalMonth = getWidget?.data?.data?.depositMonth + getWidget?.data?.data?.withdrawMonth + getWidget?.data?.data?.internalMonth;
    const totalYear = getWidget?.data?.data?.depositYear + getWidget?.data?.data?.withdrawYear + getWidget?.data?.data?.internalYear;

    const totalAllTransactions = getWidget?.data?.data?.totalDepositTransactions + getWidget?.data?.data?.totalWithdrawTransactions + getWidget?.data?.data?.totalInternalTransactions;

    return (
        <>
            <div className="row g-3">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <div className="ad_pg_cd_cnt"><h4>Users</h4>
                        <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0" >
                            <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "#B94DFF" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/user-management")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}
                                        >
                                            <div className="ad_pg_cd_lb">Total Users</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalUsers} /> </div>
                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/user-management")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}
                                        >
                                            <div className="ad_pg_cd_lb">Verified Users</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalActiveUsers} /> </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/admin-blocked-users")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}

                                        >
                                            <div className="ad_pg_cd_lb">Blocked Users</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalBlockedUsers} /></div>

                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/blocked-users")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}
                                        >
                                            <div className="ad_pg_cd_lb">Temporary Blocked Users</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.temporaryBlockedUser} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <div className="ad_pg_cd_cnt"><h4>Virtual Cards Statistics</h4>
                        <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0" >
                            <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "#7E1616" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Daily</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.CardDepositDay} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Weekly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.CardDepositWeek} /> </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Monthly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.CardDepositMonth} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Yearly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.CardDepositYear} /> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>


                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <div className="ad_pg_cd_cnt"><h4>Virtual Cards</h4>
                        <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0" >
                            <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "#4F5CFB" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/CardDepositHistory")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}
                                        >
                                            <div className="ad_pg_cd_lb">Total Card Created</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalCardDeposit} /> </div>
                                        </button>
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/TopupHistory")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}
                                        >
                                            <div className="ad_pg_cd_lb">Total Card Topup</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalCardTopup} /> </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <button
                                            className="col-auto ad_pg_cd_c"
                                            onClick={() => navigate("/CardSpendHistory")}
                                            style={{ cursor: 'pointer', background: 'unset', border: 'unset' }}
                                        >
                                            <div className="ad_pg_cd_lb">Total Card Spend</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalCardSpend} /> </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <div className="ad_pg_cd_cnt"><h4>User Statistics</h4>
                        <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0" >
                            <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "#0091C6" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Daily</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.userDay} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Weekly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.userWeek} /> </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Monthly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.userMonth} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Yearly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.userYear} /> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <div className="ad_pg_cd_cnt"><h4>Transactions Statistics</h4>
                        <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0" >
                            <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "#CA3583" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Daily</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={totalDay} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Weekly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={totalWeek} /> </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Monthly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={totalMonth} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Yearly</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={totalYear} /> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <div className="ad_pg_cd_cnt"><h4>Total Transactions</h4>
                        <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0">
                            <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(247, 102, 70)" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Total Transactions</div>
                                            <div className="ad_pg_cd_vl" style={{ marginLeft: '-70px' }} ><CountUp end={totalAllTransactions} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Internal Transactions</div>
                                            <div className="ad_pg_cd_vl" style={{ marginLeft: '-70px' }} ><CountUp end={(getWidget?.data?.data?.totalInternalTransactions)} /> </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalDepositTransactions} /></div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalWithdrawTransactions} /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

            </div>

            <div className="row gy-4">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>Polygon</h4>
                        <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(193 0 0 / 80%)" }}>
                            <div className="ad_pg_cd_rcnt tp">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/receive/POL")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> POL Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalPolygonPolDeposit} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalPolygonUsdtDeposit} /> </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div className="ad_pg_cd_rcnt bm">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/Send/POL")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> POL Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalPolygonPolWithdraw} /></div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalPolygonUsdtWithdraw} /></div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>Polygon ROU</h4>
                        <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(22, 4, 126)" }}>
                            <div className="ad_pg_cd_rcnt tp">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/receive/ROU")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> ROU Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalPolygonRouDeposit} /> </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div className="ad_pg_cd_rcnt bm">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/Send/ROU")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">ROU Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalPolygonRouWithdraw} /></div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>BNB</h4>
                        <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(24, 143, 127)" }}>
                            <div className="ad_pg_cd_rcnt tp">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/receive/BNB")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> BNB Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalBinanceBnbDeposit} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalBinanceUsdtDeposit} /> </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div className="ad_pg_cd_rcnt bm">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/Send/BNB")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> BNB Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalBinanceBnbWithdraw} /></div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalBinanceUsdtWithdraw} /></div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>ETH</h4>
                        <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(158, 32, 116)" }}>
                            <div className="ad_pg_cd_rcnt tp">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/receive/ETH")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> ETH Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalEthereumEthDeposit} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalEthereumUsdtDeposit} /> </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div className="ad_pg_cd_rcnt bm">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/Send/ETH")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> ETH Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalEthereumEthWithdraw} /></div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalEthereumUsdtWithdraw} /></div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>Tron</h4>
                        <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(129, 106, 31)" }}>
                            <div className="ad_pg_cd_rcnt tp">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/receive/TRX")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">TRX Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalTronTrxDeposit} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">USDT Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalTronUsdtDeposit} /> </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div className="ad_pg_cd_rcnt bm">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/Send/TRX")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">TRX Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalTronTrxWithdraw} /></div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">USDT Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalTronUsdtWithdraw} /></div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="ad_pg_cd_cnt"><h4>SOL</h4>
                        <div className="ad_pg_cd new-dashboard_rd" style={{ backgroundColor: "rgb(153, 70, 247)" }}>
                            <div className="ad_pg_cd_rcnt tp">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/receive/SOL")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> SOL Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalSolanaSolDeposit} /> </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Deposit</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalSolanaUsdtDeposit} /> </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div className="ad_pg_cd_rcnt bm">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0 text-white" onClick={() => navigate("/send/SOL")}>
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> SOL Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalSolanaSolWithdraw} /></div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb"> USDT Withdraw</div>
                                            <div className="ad_pg_cd_vl"><CountUp end={getWidget?.data?.data?.totalSolanaUsdtWithdraw} /></div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>





            </div >
        </>

    )
}

export default Dashboard;
